import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Response } from "@angular/http";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
// import { AppConfig } from "../app.config";
import { environment } from '../../environments/environment';

@Injectable()
export class SettingService {
  private rootUrl = "http://192.168.1.217:8000";
  settingData: any = {};
  constructor(private httpClient: HttpClient) {
    this.rootUrl = environment.API_URL
      ? environment.API_URL
      : this.rootUrl;
  }

  setSetting(options) {
    let data = {
      id: localStorage.getItem("userID"),
      options: options
    };
    return this.httpClient.post(this.rootUrl + "/options/set", data, {});
  }

  getSetting(options, id = null) {
    let data = {
      id: id != null ? id : (localStorage.getItem("userID")),
      options: options
    };

    return this.httpClient.post(this.rootUrl + "/options/get", data, {});
  }
  setSettingNew(options, groupId) {
    let data = {
      id: localStorage.getItem("userID"),
      group_id: groupId,
      options: options
    };
    return this.httpClient.post(this.rootUrl + "/options/set", data, {});
  }
  setMatrixSetting(data) {
    // let data = {
    //   id: localStorage.getItem("userID"), 
    //   group_id:groupId,    
    //   options: options
    // };
    return this.httpClient.post(this.rootUrl + "/options/set", data, {});
  }

  getSettingNew(options, groupId) {
    this.settingData = {
      id: localStorage.getItem("userID"),
      options: options
    };
    if (groupId && groupId != '') {
      this.settingData.group_id = groupId;
    }
    return this.httpClient.post(this.rootUrl + "/options/get", this.settingData, {});
  }

  setSettingWithType(options, settingType) {
    let data = {
      id: localStorage.getItem("userID"),
      settingType: settingType,
      options: options
    };
    return this.httpClient.post(this.rootUrl + "/options/set", data, {});
  }
  
  getUniversalOptions(options) {
    let data = {
      options: options
    };
    return this.httpClient.post(this.rootUrl + "/options/getUniversalOptions", data, {});
  }
  setUniversalOptions(options) {
    let data = {
      options: options
    };
    return this.httpClient.post(this.rootUrl + "/options/setUniversalOptions", data, {});
  }

  isAccessInvoiceType(orderType: string, isPublicQuote: boolean, isInvoiceEditable: number) {
    let redirectUrl = '';

    if (orderType == 'Invoice' && isInvoiceEditable === 0) {
      if (isPublicQuote == true) {
        redirectUrl = '/builder/invoices/order';
      }
      else {
        redirectUrl = '/invoices/order';
      }
    }

    return redirectUrl;
  }

  getTooltipOptions() {
    const options = [
      'tooltip_height',
      'tooltip_width',
      'tooltip_distance'
    ];
    const data = {
      options: options
    };
    return this.httpClient.post(this.rootUrl + "/options/getUniversalOptions", data, {});
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/_services/setting.service.ts